import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: null,
    userRole: null,
    userShopID: null,
    bottleId: null,
    bottleIdList: [],
    bottleListData: [],
    isMultiple: null,
    bottleInfo: {
      button: []
    },
    bottleInfoCache: {
      button: []
    },
    location: {},
    startRouter: null,
    isTest: false,
    time: null
  },
  mutations: {
    setState(state,{name, value}){
      state[name] = value
    },
    getTestStatus(state){
      if(process.env.VUE_APP_BASE_API == '/api')return state.isTest = true
      if(JS.getIsDebug && JS.getIsDebug() != 'false')return state.isTest = true
    }
  },
  actions: {
  },
  getters: {
  },
  modules: {
  }
})
